module.exports = __webpack_public_path__ + "img/1440.1436fd80.jpg";